import Controller from "csi/action/Controller";
import PostRequest from "csi/comm/PostRequest";
import locale from "csi/locale";
import MessageDialog from "csi/widget/MessageDialog";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const UnlinkSizeChartController = declare(Controller, {
	/**
     * @override
     */
	preProcess() {
		this.confirmAction({});
	},

	/**
     * On confirm proceed with unlinking of SizeChart from Shape
     * On cancel refresh the row so that the toggle is rendered correctly
     * @param {String} key - the button key hit by user
     */
	onConfirm(key: String) {
		if (key == MessageDialog.BUTTON_UNLINK) {
			this.process();
		} else {
			this.getContext().view.redrawNode(this.m_element);
			this.postProcess();
		}
	},

	/**
     * Prompt confirmation with buttons “Unlink” and “Cancel”.
     * @override
     */
	confirmAction(params: any) {
		params.title = locale.resource(this.getContext().ac.m_action.m_id);
		params.message = locale.typeAction("SizeChart", "ClearSizeChartLinksToShape_Confirm");
		params.buttons = [MessageDialog.BUTTON_UNLINK, MessageDialog.BUTTON_CANCEL];

		this.inherited(arguments);
	},

	/**
     * @override
     */
	process() {
		const postReq = new PostRequest("ProductSpec", "ActionOnToggleClearSizeChartLinksToShape")
			.addParameter("URL", this.m_urlNode);
		this.waitForPublish(postReq.post(), true);
		this.getContext().view.redrawNode(this.m_element);
	},
});

export = UnlinkSizeChartController;